import React, { useContext, useEffect, useState } from "react";
import {
  DeleteIcon,
  DollarIcon,
  UserIcon,
  WatchlistIcon,
} from "../../GlobalIcons";
import "./style.css";
import { filterDataContext } from "../../../App";
import { REMOVE_FROM_WATCHLIST_API } from "../../../APIs";
import NotifyDeleteButton from "../../notifyDeleteButton";
import { MdEmail } from "react-icons/md";

import LogOutButton from "../../LogoutButton";
const HeaderPopups = ({ parent }) => {

  const { whislistItem, setWhishListItem, fetchWatchListItem, profileData } = useContext(filterDataContext)

  const handleRemoveFromWatchList = async (id) => {
    try {
      const response = await REMOVE_FROM_WATCHLIST_API(id)
      if (response && response?.status) {
        fetchWatchListItem()
      }
    } catch (error) {
      console.log(error, "REMOVE_WISHLIST_API")
    }
  }


  useEffect(() => {
    fetchWatchListItem()
  }, [])


  return (
    <>
      {parent === "account" && (
        <div className="account_popup_sec">
          <div className="popup_inner_sections">
            <div className="section1">
              <div className="user_icon">
                <UserIcon />
              </div>
            </div>
            <div className="section2">
              <h1>{`${profileData?.fname}`}</h1>
            </div>
            {/* <div className="section3">
              <button>View Profile</button>
            </div> */}
          </div>

          <div className="popup_footer">
            <h4>
              <span>
                <MdEmail />
              </span>
              {profileData?.email}
            </h4>
          </div>
        </div>
      )}

      {parent === "notification" && (
        <div className="notification_popup_sec">
          <div className="popup_bell_headr">
            <p>Watchlist</p>
            <p>
              <WatchlistIcon />
            </p>
          </div>
          <div className="notification_bar">
            {whislistItem.length > 0 ? whislistItem?.map((item) => (
              <div className="notifications">
                <div className="notifi_text">
                  {
                    item.categoryName ?
                      <>
                        <h1>{item.eventName}</h1>
                        <p>{item.categoryName}</p>
                      </>
                      :
                      <>
                        <h1>{item.eventName}</h1>
                        {/* <p>{item.season}</p> */}
                      </>
                  }
                </div>
                <NotifyDeleteButton onClick={() => handleRemoveFromWatchList(item?.id)} />
              </div>
            ))
              :
              <p className="wishlist_cart_error" >
                No items added in wishlist
              </p>
            }
          </div>
        </div>
      )}
    </>
  );
};

export default HeaderPopups;
